/* eslint-disable import/prefer-default-export */
import isEmpty from 'lodash.isempty';

const formatAvailableDaysFromSchedules = (schedule) => {
  const arrayOfWeekdays = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  const today = new Date();
  const weekdayNumber = today.getDay();

  return Object.entries(schedule).reduce((acc, [key, value]) => {
    if (key.endsWith('dag') && !isEmpty(value)) {
      const isCurrentDay = arrayOfWeekdays[weekdayNumber] === key;
      const obj = {
        day: key,
        timeframes: value,
        isCurrentDay,
      };
      return [...acc, obj];
    }
    return [...acc];
  }, []);
};

export { formatAvailableDaysFromSchedules };
